(function () {
  // VW UK — Free item reward ladder (cart side).
  // The rest of the order unlocks FREE ITEMs at fixed thresholds:
  //   £50 = 1 free item, £125 = 2, £200 = 3.
  // Keep TIERS_CENTS in sync with assets/vw-gift-guard.js,
  // snippets/cart-summary.liquid and snippets/variant-main-picker.liquid.
  // The FREE ITEM variant is priced £0.00, so no discount code is applied:
  // applying one (e.g. FREEGIFT50) would replace whatever code the customer
  // already has (SHIP2MEFREE, BUNDLE10), because none of them combine.
  // The bundle builder postage line (£5.45) doesn't count towards the
  // thresholds — keep POSTAGE_VARIANT_ID in sync with assets/vw-app.js.
  var GIFT_VARIANT_ID = 58593137492300;
  var POSTAGE_VARIANT_ID = 59612394848588;
  var TIERS_CENTS = [5000, 12500, 20000];
  var reverting = false;
  var reloadTriggered = false;

  // True while the gift button flow is mid-navigation, so the watcher
  // doesn't act in the window between the add and the page reload.
  window.__vwGiftBusy = false;

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function giftLines(cart) {
    return cart.items.filter(function (item) { return item.variant_id === GIFT_VARIANT_ID; });
  }

  function otherItemsSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id !== GIFT_VARIANT_ID && item.variant_id !== POSTAGE_VARIANT_ID) total += item.line_price;
    });
    return total;
  }

  function allowedGifts(cart) {
    var sub = otherItemsSubtotal(cart);
    return TIERS_CENTS.filter(function (t) { return sub >= t; }).length;
  }

  // Trim the FREE ITEM quantity back down to what the cart has unlocked
  function trimGifts(lines, allowed) {
    if (reverting || reloadTriggered) return;
    reverting = true;
    var updates = {};
    var keep = allowed;
    lines.forEach(function (line) {
      var q = Math.min(line.quantity, keep);
      updates[line.key] = q;
      keep -= q;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        reloadTriggered = true;
        alert(
          allowed > 0
            ? 'Your order now unlocks ' + allowed + ' free item' + (allowed === 1 ? '' : 's') + ' (1 at £50, 2 at £125, 3 at £200), so we\'ve adjusted your free items.'
            : 'Free items unlock once the rest of your order reaches £50 — your free item has been removed.'
        );
        window.location.reload();
      })
      .finally(function () {
        reverting = false;
      });
  }

  function reconcile() {
    if (window.__vwGiftBusy || reverting || reloadTriggered) return;
    fetchCart().then(function (cart) {
      var lines = giftLines(cart);
      if (!lines.length) return;
      var inCart = lines.reduce(function (sum, l) { return sum + l.quantity; }, 0);
      var allowed = allowedGifts(cart);
      if (inCart > allowed) trimGifts(lines, allowed);
    });
  }

  // Re-check after any cart change (add / change / update / clear), but not
  // after plain /cart.js reads, so the check can't trigger itself in a loop.
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var urlArg = args[0];
    var url = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
    var isCartChange = /\/cart(\/|$)/i.test(url) && !/\/cart\.js/i.test(url);
    var result = origFetch.apply(this, args);
    if (isCartChange) {
      result.then(function (res) {
        setTimeout(reconcile, 300);
        return res;
      });
    }
    return result;
  };

  reconcile();

  // "Add your free item(s)" button on the cart reward ladder: adds however
  // many free items are unlocked but not yet claimed, then reloads /cart.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-vw-gift-add]');
    if (!btn) return;

    var banner = btn.closest('[data-vw-gift-banner]');
    if (!banner) return;

    var variantId = parseInt(banner.getAttribute('data-gift-variant-id'), 10);
    var qty = parseInt(btn.getAttribute('data-gift-qty'), 10) || 1;
    var originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding...';
    window.__vwGiftBusy = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add the free item');
          });
        }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('VW gift button failed:', err);
        window.__vwGiftBusy = false;
        btn.disabled = false;
        btn.textContent = originalText;
        alert(err && err.message ? err.message : "Sorry, we couldn't add your free item. Please try again.");
      });
  });
})();
